import React, { Component } from 'react';
import { Link } from 'react-router';

import Select from "react-select";

import BandStore from "../stores/BandStore";
import ChannelStore from "../stores/ChannelStore";
import SessionStore from "../stores/SessionStore";
import OrganizationStore from "../stores/OrganizationStore";



class RegisterComponent extends Component {
  handleDeleteRegister(e) {
    e.preventDefault();

    this.props.deleteRegister(this.props.index);
  }

  onChange(field, e) {
    this.props.changeRegister(this.props.index, field, e)
  };

  render() {
    return(
      <div className="panel panel-default">

        <div className="panel panel-heading">
          Modbus register #{this.props.index + 1}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          [&nbsp;<Link><a href="" onClick={this.handleDeleteRegister.bind(this)}>Delete</a></Link>&nbsp;]
        </div>
        
        <div className="panel-body">  

          <div className="form-group">
            <label className="control-label" htmlFor="name">Name</label>
            <input className="form-control" id="name" type="text" required pattern="([^/]+)" value={this.props.name || ''} onChange={this.onChange.bind(this, 'name')} />
          </div>

          <div className={((this.props.apptype === 5) ? 'hidden' : 'form-group')}>
            <label className="control-label" htmlFor="cmd">Query command (1-255)</label>
            <input className="form-control" id="cmd" type="number" required value={this.props.cmd} onChange={this.onChange.bind(this, 'cmd')} />
          </div>

          <div className="form-group">
            <label className="control-label" htmlFor="regAddress">Register address (0 - 65535)</label>
            <input className="form-control" id="regAddress" type="number" required value={typeof this.props.regAddress !== 'undefined' ? this.props.regAddress : ''} onChange={this.onChange.bind(this, 'regAddress')} />
          </div>

          <div className="form-group">
            <label className="control-label" htmlFor="regType">Data type</label>
              <select className="form-control" id="regType" name="regType" required value={this.props.regType || 'uint16'} onChange={this.onChange.bind(this, "regType")}>
                <option key="int16" value="int16">int16</option>
                <option key="uint16" value="uint16">uint16</option>
                <option key="int32" value="int32">int32</option>
                <option key="uint32" value="uint32">uint32</option>
                <option key="uint64" value="uint64">uint64</option>
                <option key="float32" value="float32">float32</option>
                <option key="float32-2301" value="float32-2301">float32-2301</option>
                <option key="float64" value="float64">float64</option>
                <option key="float64-67452301" value="float64-67452301">float64-67452301</option>
                <option key="BCD32" value="BCD32">BCD32</option>
                <option key="BCD64" value="BCD64">BCD64</option>
                <option key="String" value="String" className={((this.props.apptype === 5) ? '' : 'hidden')}>String</option>
              </select>        
          </div>

        </div>

      </div>
    )
  }
}


class ExReadingComponent extends Component {
  handleDeleteExReading(e) {
    e.preventDefault();

    this.props.deleteExReading(this.props.index);
  }

  onChange(field, e) {
    this.props.changeExReading(this.props.index, field, e)
  };

  render() {
    return(
      <div className="panel panel-default">

        <div className="panel panel-heading">
          Extend meter reading #{this.props.index + 1}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          [&nbsp;<Link><a href="" onClick={this.handleDeleteExReading.bind(this)}>Delete</a></Link>&nbsp;]
        </div>
        
        <div className="panel-body">  

          <div className="form-group">
            <label className="control-label" htmlFor="name">Name</label>
            <input className="form-control" id="name" type="text" required value={this.props.name || ''} onChange={this.onChange.bind(this, 'name')} />
          </div>

          <div className="form-group">
            <label className="control-label" htmlFor="eid">Index (1-19)</label>
            <input className="form-control" id="eid" type="number" required value={this.props.eid} onChange={this.onChange.bind(this, 'eid')} />
          </div>

          <div className="form-group">
            <label className="control-label" htmlFor="unit">Unit</label>
            <input className="form-control" id="unit" type="text" value={this.props.unit || ''} onChange={this.onChange.bind(this, 'unit')} />
          </div>

          <div className="form-group">
            <label className="control-label" htmlFor="formula">Formula(like: e4, Represents an extended reading raw value with index 4)</label>
            <input className="form-control" id="formula" type="text"  value={this.props.formula || ''} onChange={this.onChange.bind(this, 'formula')} />
          </div>

          <div className="form-group">
            <label className="control-label" htmlFor="scale">Scale</label>
            <input className="form-control" id="scale" type="number" required value={this.props.scale || '0'} onChange={this.onChange.bind(this, 'scale')} />
            <p className="help-block">The number of decimal digits for result.</p>
          </div>

        </div>

      </div>
    )
  }
}



class DlmsComponent extends Component {
  handleDeleteDlms(e) {
    e.preventDefault();

    this.props.deleteDlms(this.props.index);
  }

  onChange(field, e) {
    this.props.changeDlms(this.props.index, field, e)
  };

  render() {
    return(
      <div className="panel panel-default">

        <div className="panel panel-heading">
          DLMS Register #{this.props.index + 1}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          [&nbsp;<Link><a href="" onClick={this.handleDeleteDlms.bind(this)}>Delete</a></Link>&nbsp;]
        </div>
        
        <div className="panel-body">  

          <div className="form-group">
            <label className="control-label" htmlFor="name">Name</label>
            <input className="form-control" id="name" type="text" required value={this.props.name} onChange={this.onChange.bind(this, 'name')} />
          </div>

          <div className="form-group">
            <label className="control-label" htmlFor="classID">Class ID</label>
            <input className="form-control" id="classID" type="number" value={this.props.classID} onChange={this.onChange.bind(this, 'classID')} />
          </div>

          <div className="form-group">
            <label className="control-label" htmlFor="obis">OBIS Code</label>
            <input className="form-control" id="obis" type="text" value={this.props.obis} onChange={this.onChange.bind(this, 'obis')} />
            <p className="help-block">OBIS code like: A.B.C.D.E.F. For example: 1.0.15.8.0.255</p>
          </div>

          <div className="form-group">
            <label className="control-label" htmlFor="attr">Attribute</label>
            <input className="form-control" id="attr" type="number" value={this.props.attr} onChange={this.onChange.bind(this, 'attr')} />
          </div>

          <div className="form-group">
            <label className="control-label" htmlFor="mul">Multiply</label>
            <select className="form-control" id="mul" name="mul" required value={this.props.mul} onChange={this.onChange.bind(this, "mul")}>
              <option key="-9" value="-9">/10^9</option>
              <option key="-8" value="-8">/10^8</option>
              <option key="-7" value="-7">/10^7</option>
              <option key="-6" value="-6">/10^6</option>
              <option key="-5" value="-5">/10^5</option>
              <option key="-4" value="-4">/10^4</option>
              <option key="-3" value="-3">/1000</option>
              <option key="-2" value="-2">/100</option>
              <option key="-1" value="-1">/10</option>
              <option key="0" value="0">*1</option>
              <option key="1" value="1">*10</option>
              <option key="2" value="2">*100</option>
              <option key="3" value="3">*1000</option>
            </select>
            <p className="help-block">Real reading = value*Multiply*Ratio</p>
          </div>

          <div className="form-group">
            <label className="control-label" htmlFor="ratio">Ratio</label>
            <input className="form-control" id="ratio" type="number" value={this.props.ratio} onChange={this.onChange.bind(this, 'ratio')} />
            <p className="help-block">1-30000. Real reading = value*Multiply*Ratio</p>
          </div>


        </div>

      </div>
    )
  }
}


class TimerComponent extends Component {
  handleDeleteTimer(e) {
    e.preventDefault();

    this.props.deleteTimer(this.props.index);
  }

  onChange(field, e) {
    this.props.changeTimer(this.props.index, field, e)
  };

  render() {
    return(
      <div className="panel panel-default">

        <div className="panel panel-heading">
          Timer #{this.props.index + 1}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          [&nbsp;<Link><a href="" onClick={this.handleDeleteTimer.bind(this)}>Delete</a></Link>&nbsp;]
        </div>
        
        <div className="panel-body">  

          <div className="form-group">
            <label className="control-label" htmlFor="timerType">Type</label>
            <select className="form-control" id="timerType" name="timerType" required value={this.props.timerType || 0} onChange={this.onChange.bind(this, "timerType")}>
              <option key="0" value="0">Repeat</option>
              <option key="1" value="1">Once</option>
            </select>        
            <p className="help-block">Repeat timer: The action is repeated every day.</p>
            <p className="help-block">Once timer: The action is only executed once.</p>
          </div>

          <div className="form-group">
            <label className="control-label" htmlFor="time">Time</label>
            <input className="form-control" id="time" type="text" required pattern="([^/]+)" value={this.props.time || ''} onChange={this.onChange.bind(this, 'time')} />
            <p className="help-block">Repeat timer format: hh:mm, like: 18:30</p>
            <p className="help-block">Once timer format: YYYY-MM-DD hh:mm:ss, like: 2021-7-20 20:30:00</p>
          </div>

          <div className="form-group">
            <label className="control-label" htmlFor="action">Action</label>
            <select className="form-control" id="action" name="action" required value={this.props.action || 0} onChange={this.onChange.bind(this, "action")}>
              <option key="0" value="0">OFF</option>
              <option key="1" value="1">ON</option>
            </select>
            <p className="help-block">ON: turn on the light; OFF: turn off the light.</p>
          </div>

          <div className="form-group">
            <label className="control-label" htmlFor="brightness">Brightness (0-100)</label>
            <input className="form-control" id="brightness" type="number" required value={this.props.brightness} onChange={this.onChange.bind(this, 'brightness')} />
          </div>

        </div>

      </div>
    )
  }
}


class ReportComponent extends Component {
  handleDeleteReport(e) {
    e.preventDefault();

    this.props.deleteReport(this.props.index);
  }

  onChange(field, e) {
    this.props.changeReport(this.props.index, field, e)
  };

  render() {
    return(
      <div className="panel panel-default">
      
        <div className="panel panel-heading">
          Report #{this.props.index + 1}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          [&nbsp;<Link><a href="" onClick={this.handleDeleteReport.bind(this)}>Delete</a></Link>&nbsp;]
        </div>
        
        <div className="panel-body">  

          <div className="form-group">
            <label className="control-label" htmlFor="id">ID</label>
            <input className="form-control" id="id" type="number" required value={this.props.id || ''} onChange={this.onChange.bind(this, 'id')} />
            <p className="help-block">The unique Identification of this report. It should >= 1.</p>
          </div>

          <div className="form-group">
            <label className="control-label" htmlFor="name">Name</label>
            <input className="form-control" id="name" type="text" required value={this.props.name || ''} onChange={this.onChange.bind(this, 'name')} />
          </div>

          <div className="form-group">
            <label className="control-label" htmlFor="formula">Formula(like: r4, means the value of register which address is 4 define above)</label>
            <input className="form-control" id="formula" type="text" required value={this.props.formula || ''} onChange={this.onChange.bind(this, 'formula')} />
          </div>

          <div className="form-group">
            <label className="control-label" htmlFor="scale">Scale</label>
            <input className="form-control" id="scale" type="number" required value={this.props.scale || '0'} onChange={this.onChange.bind(this, 'scale')} />
            <p className="help-block">The number of decimal digits for result.</p>
          </div>

        </div>

      </div>
    )
  }
}



class BACnetComponent extends Component {
  onChange(field, e) {
    this.props.onChangeBACnet(this.props.index, field, e);
  };

  render() {
    let bacnetUnit = this.props.unit;
    if (bacnetUnit !== 3 && bacnetUnit !== 5 && bacnetUnit !== 19
      && bacnetUnit !== 48 && bacnetUnit !== 80 && bacnetUnit !== 98
      && bacnetUnit !== 95) 
    {
      bacnetUnit = 65535;
    }

    return(
      <div className="panel panel-default">

        <div className="panel panel-heading">
          <input type="checkbox" id={this.props.id} checked={this.props.enable?true:false} onChange={this.onChange.bind(this, 'isBACnetEnable')} />
          &nbsp;&nbsp;&nbsp;{this.props.name}
        </div>

        <div className={'panel-body' + (this.props.enable ? '':' hidden')}>

          <div className="form-group">
            <label className="control-label" htmlFor="bacnetUnit">Unit</label>
            <select className="form-control" id="bacnetUnit" name="bacnetUnit" value={bacnetUnit} onChange={this.onChange.bind(this, "bacnetUnit")}>
              <option key="3" value="3">Ampers</option>
              <option key="5" value="5">Volts</option>
              <option key="19" value="19">kWh</option>
              <option key="48" value="48">kW</option>
              <option key="80" value="80">m^3</option>
              <option key="98" value="98">%</option>
              <option key="95" value="95">No units</option>
              <option key="65535" value="65535">Others</option>
            </select>
          </div>

          <div className="form-group">
            <label className="control-label" htmlFor="unitValue">Unit Value</label>
            <input className="form-control" id="unitValue" type="number" required value={this.props.unit || '95'} onChange={this.onChange.bind(this, 'unitValue')} />
            <p className="help-block">The values defined for units in the BACnet standard.</p>
          </div>

          <div className="form-group">
            <label className="control-label" htmlFor="mul">Multiply</label>
            <select className="form-control" id="mul" name="mul" required value={this.props.mul} onChange={this.onChange.bind(this, "unitMul")}>
              <option key="-9" value="-9">/10^9</option>
              <option key="-8" value="-8">/10^8</option>
              <option key="-7" value="-7">/10^7</option>
              <option key="-6" value="-6">/10^6</option>
              <option key="-5" value="-5">/10^5</option>
              <option key="-4" value="-4">/10^4</option>
              <option key="-3" value="-3">/1000</option>
              <option key="-2" value="-2">/100</option>
              <option key="-1" value="-1">/10</option>
              <option key="0" value="0">*1</option>
              <option key="1" value="1">*10</option>
              <option key="2" value="2">*100</option>
              <option key="3" value="3">*1000</option>
            </select>
            <p className="help-block">BACnet value = value*Multiply</p>
          </div>
        </div>

    </div>
  )
  }
}



class AlarmComponent extends Component {
  handleDeleteAlarm(e) {
    e.preventDefault();

    this.props.deleteAlarm(this.props.index);
  }

  onChange(field, e) {
    this.props.changeAlarm(this.props.index, field, e)
  };

  render() {
    return(
      <div className="panel panel-default">
      
        <div className="panel panel-heading">
          Alarm #{this.props.index + 1}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          [&nbsp;<Link><a href="" onClick={this.handleDeleteAlarm.bind(this)}>Delete</a></Link>&nbsp;]
        </div>
        
        <div className="panel-body">  
          <div className="form-group">
            <label className="control-label" htmlFor="msg">Message</label>
            <input className="form-control" id="msg" type="text" required value={this.props.msg || ''} onChange={this.onChange.bind(this, 'msg')} />
          </div>

          <div className="form-group">
                <div className="checkbox">
                  <label>
                    <input type="checkbox" id="localalarm" checked={this.props.localalarm} onChange={this.onChange.bind(this, 'localalarm')} /> Cheak alarm locally
                  </label>
                </div>
                <label className="control-label" htmlFor="localalarm">
                If this parameter is selected, Condition can be configured only in (xn&gt;value)  and (xn&lt; value) formats(n&gt;0). In addition, the reported data items referenced in Reports can only be set into rn form and cannot be used for complex calculations</label>
          </div>

          <div className="form-group">
            <label className="control-label" htmlFor="formula">Condition&nbsp;(like: x1&gt;100, &nbsp;a2-a1&lt;0. &nbsp;Basic reading is a1..., extended reading is x1...)</label>
            <input className="form-control" id="formula" type="text" required value={this.props.formula || ''} onChange={this.onChange.bind(this, 'formula')} />
          </div>

        </div>

      </div>
    )
  }
}


class DisplayComponent extends Component {
  onDisplayChange(e) {
    this.props.onDisplayChange(this.props.id, e);
  };

  render() {
    return(
      <div className="form-group">
        <input type="checkbox" id={this.props.id} checked={this.props.hide?false:true} onChange={this.onDisplayChange.bind(this)} />
        &nbsp;&nbsp;{this.props.name}
      </div>
    )
  }
}


class ApplicationForm extends Component {
  constructor() {
    super();
    this.state = {
      activeTab: "application",
      customServer: SessionStore.customServer,
      application: {
        appType: 0,
        exReading: [],
        rs485Config: {
          serialConfig: {
            devType: 0,
            baudrate: 6,
            stopbit: 0,
            parity: 0,
            addrSize: 4,
            hdlcDstHigh: '',
            hdlcDstLow: '',
            wrapperSrc: '',
            wrapperDst: '',
            authLevel: 0,
            authPasswd: '',
          },
          dlmsRegs: [],
          regs:   [], 
          reports:  [], 
        },
        bacnetConfig: {
          bacnetItems: [],
        },
        alarmConfig: {
          flags: 0, 
          alarmItems: [],
        },
        hideDisplay: ['recharge', 'valve', 'lc', 'errCount'],
        timerConfig: {
          flags: 0,
          timerItems: [],
        },
      },
      bands: [],
      channelLists: [],
      isGlobalAdmin: false,
      appTypeDisabled: false,
      allLoRaNodeBaiscDisplay: [
        //{id:"devEUI", name:"Device EUI"}, 唯一标识，必须显示
        {id:"sn", name:"Serial number"},
        {id:"meterReading", name:"Meter reading"},
        {id:"recharge", name:"Prepayment"},
        {id:"valve", name:"Valve status"},
        {id:"rssi", name:"RSSI"},
        {id:"snr", name:"SNR"},
        {id:"battery", name:"Battery"},
        {id:"lc", name:"Sensor LC"},
        {id:"lastUpdate", name:"Data Time"},
        {id:"lastActive", name:"Transimit Time"},
        {id:"rebootCount", name:"Reboot count"},
        {id:"errCount", name:"Error count"},
        {id:"softVer", name:"Software version"},
        {id:"address", name:"Address"},
        {id:"MCUTemp", name:"Temperature"},
      ],
      allSubMeterBaiscDisplay: [
        //{id:"sn", name:"Serial number"},  唯一标识，必须显示
        {id:"devEUI", name:"LoRa-485 bridge's device EUI"},
        {id:"modbusAddress", name:"Modbus address"},
        {id:"rssi", name:"RSSI"},
        {id:"snr", name:"SNR"},
        {id:"lastUpdate", name:"Data Time"},
        {id:"lastActive", name:"Transimit Time"},
        {id:"address", name:"Address"},
      ],

      // 当前显示出来的所有, 成员有:
      // [index 0-n], enable, isBase, name , unit, mul
      allBacnet: [],
      // 显示的基础部分
      bacnetBaseFields: [
        {name:"meterReading", unit:80, mul: -3},
        {name:"battery", unit:98, mul: 0},
        {name:"rssi", unit:95, mul: 0},
        {name:"loRaSNR", unit:95, mul: 0},
        {name:"fCnt", unit:95, mul: 0},
      ],
    };

    this.state.allBacnet = this.buildBACnet(false, this.state.application);

    BandStore.getAll("", 9999, 0, (totalCount, bands) => {
      this.setState({bands: bands})
    });

    ChannelStore.getAllChannelLists((lists) => {
      this.setState({channelLists: lists});
    });

    this.handleSubmit = this.handleSubmit.bind(this);
    this.changeTab = this.changeTab.bind(this);
    this.onOrganizationAutocomplete = this.onOrganizationAutocomplete.bind(this);
    this.onOrganizationSelect = this.onOrganizationSelect.bind(this);
    this.setSelectedOrganization = this.setSelectedOrganization.bind(this);
    
    this.handleAddExReading = this.handleAddExReading.bind(this);
    this.changeExReading = this.changeExReading.bind(this);
    this.deleteExReading = this.deleteExReading.bind(this);

    this.handleAddDlms = this.handleAddDlms.bind(this);
    this.changeDlms = this.changeDlms.bind(this);
    this.deleteDlms = this.deleteDlms.bind(this);

    this.handleAddRegister = this.handleAddRegister.bind(this);
    this.changeRegister = this.changeRegister.bind(this);
    this.deleteRegister = this.deleteRegister.bind(this);

    this.handleAddReport = this.handleAddReport.bind(this);
    this.changeReport = this.changeReport.bind(this);
    this.deleteReport = this.deleteReport.bind(this);

    this.handleAddTimer = this.handleAddTimer.bind(this);
    this.changeTimer = this.changeTimer.bind(this);
    this.deleteTimer = this.deleteTimer.bind(this);

    this.handleAddAlarm = this.handleAddAlarm.bind(this);
    this.changeAlarm = this.changeAlarm.bind(this);
    this.deleteAlarm = this.deleteAlarm.bind(this);

    this.onDisplayChange = this.onDisplayChange.bind(this);
    this.onSerialChange = this.onSerialChange.bind(this);

    this.buildBACnet = this.buildBACnet.bind(this);
    this.onChangeBACnet = this.onChangeBACnet.bind(this);
    this.getBACnetPrevCfg = this.getBACnetPrevCfg.bind(this);
  }

  // 添加一个到列表中
  hideListAdd(id) {
    let application = this.props.application;
    if (typeof application.hideDisplay === 'undefined') {
      application.hideDisplay = [];
    }

    if (this.hideListInclude(application.hideDisplay, id)) {
      console.log("hideListAdd is already exist: ", id);
      return;
    }

    application.hideDisplay.push(id);

    console.log("hideListAdd id=", id, ", list=", application.hideDisplay);

    this.setState({
      application: application,
      customServer: SessionStore.customServer,
    });
  }

  // 从列表中删除一个
  hideListDel(id) {
    let application = this.props.application;
    if (typeof application.hideDisplay === undefined) {
      application.hideDisplay = [];
    }
    
    for (var i = 0; i < application.hideDisplay.length; i++) {
      if (application.hideDisplay[i] === id) {
        application.hideDisplay.splice(i, 1);
        console.log("hideListDel id=", id, ", list=", application.hideDisplay);
        this.setState({
          application: application,
        });
        return;
      }
    }

    console.log("hideListDel not found: ", id);
  }

  // 检查是否包含
  hideListInclude(list, id) {
    if (typeof list === 'undefined')
      return false;

    for (var i in list) {
      if (list[i] === id)
        return true;
    }

    return false;
  }
  
  onChangeBACnet(index, field, e) {
    let abs = this.state.allBacnet;

    // app.bacnetConfig 只记录使能的字段

    if (field === "isBACnetEnable") {
      abs[index].enable = e.target.checked;
    } else if (field === "bacnetUnit") {
      let value = parseInt(e.target.value, 10);
      let unitValue = value;
      if (value === 65535) {
        unitValue = 95;
      }
      abs[index].unit = unitValue;
    } else if (field === "unitValue") {
      abs[index].unit = parseInt(e.target.value, 10);
    } else if (field === "unitMul") {
      abs[index].mul = parseInt(e.target.value, 10);
    }

    this.setState({allBacnet : abs});
  }

  getBACnetPrevCfg(name, isProps, app) {
    let ret = {found: false, enable: false, unit: 95, mul: 0};

    if (isProps) { // 从配置中来，有的话一定是使能的
      if (typeof app.bacnetConfig !== 'undefined' && typeof app.bacnetConfig.bacnetItems !== 'undefined') {
        for (let i = 0; i < app.bacnetConfig.bacnetItems.length; i++) {
          let src = app.bacnetConfig.bacnetItems[i];
          if (src.name === name) {
            ret.found = true;
            ret.enable = true;
            ret.unit = src.unit;
            ret.mul = src.mul;
            break;
          }
        }
      }
    } else { // 从当前设置来
      for (let i = 0; i < this.state.allBacnet.length; i++) {
        let src = this.state.allBacnet[i];
        if (src.name === name) {
          ret.found = true;
          ret.enable = src.enable;
          ret.unit = src.unit;
          ret.mul = src.mul;
          break;
        }
      }
    }

    return ret;
  }

  // 有配置变化时，更新内部数据/视图
  buildBACnet(isProps, app) {
    var src;
    var prev;
    var b;
    let bs = [];

    // 先构建常规的
    for (let i = 0; i < this.state.bacnetBaseFields.length; i++) {
      src = this.state.bacnetBaseFields[i];
      prev = this.getBACnetPrevCfg(src.name, isProps, app);
      if (prev.found) {
        b = {enable: prev.enable, isBase: true, name: src.name, unit: prev.unit, mul: prev.mul};
      } else {
        b = {enable: false, isBase: true, name: src.name, unit: src.unit, mul: src.mul};
      }
      bs.push(b);
    }

    // 再构建扩展的
    if (app.exReading.length > 0) {
      for (let i = 0; i < app.exReading.length; i++) {
        src = app.exReading[i];
        if (typeof src.name === 'undefined' || src.name === "") {
          continue;
        }

        prev = this.getBACnetPrevCfg(src.name, isProps, app);

        if (prev.found) {
          b = {enable: prev.enable, isBase: true, name: src.name, unit: prev.unit, mul: prev.mul};
        } else {
          b = {enable: false, isBase: false, name: src.name, unit: 95, mul: 0};
        }

        bs.push(b);
      }
    }
    if (app.rs485Config.reports.length > 0) {
      for (let i = 0; i < app.rs485Config.reports.length; i++) {
        src = app.rs485Config.reports[i];
        if (typeof src.name === 'undefined' || src.name === "") {
          continue;
        }

        prev = this.getBACnetPrevCfg(src.name, isProps, app);

        if (prev.found) {
          b = {enable: prev.enable, isBase: true, name: src.name, unit: prev.unit, mul: prev.mul};
        } else {
          b = {enable: false, isBase: false, name: src.name, unit: 95, mul: 0};
        }

        bs.push(b);
      }
    }

    return bs;
  }


  componentWillUpdate(nextProps, nextState) {
    let isProps = false;
    if (typeof nextState.isProps !== 'undefined') {
      isProps = nextState.isProps;
    }
    
    let abs = this.buildBACnet(isProps, nextState.application);
    nextState.allBacnet = abs;

    nextState.isProps = false;
  }

  componentDidMount() {
    if (typeof this.props.application.rs485Config === 'undefined') {
      this.props.application.rs485Config = {};
    }
    if (typeof this.props.application.rs485Config.serialConfig === 'undefined') {
      this.props.application.rs485Config.serialConfig = {
        devType: 0,
        baudrate: 6,
        stopbit: 0,
        parity: 0,
        addrSize: 4,
        hdlcDstHigh: '',
        hdlcDstLow: '',
        wrapperSrc: '',
        wrapperDst: '',
        authLevel: 0,
        authPasswd: '',
      };
    }
    if (typeof this.props.application.rs485Config.dlmsRegs === 'undefined') {
      this.props.application.rs485Config.dlmsRegs = [];
    }
    if (typeof this.props.application.rs485Config.regs === 'undefined') {
      this.props.application.rs485Config.regs = [];
    }
    if (typeof this.props.application.rs485Config.reports === 'undefined') {
      this.props.application.rs485Config.reports = [];
    }
    if (typeof this.props.application.hideDisplay === 'undefined') {
      this.props.application.hideDisplay = ['recharge', 'valve', 'lc', 'errCount'];
    }
    if (typeof this.props.application.appType === 'undefined') {
      this.props.application.appType = 0;
    }
    if (typeof this.props.application.exReading === 'undefined') {
      this.props.application.exReading = [];
    }
    if (typeof this.props.application.bacnetConfig === 'undefined') {
      this.props.application.bacnetConfig = [];
    }
    if (typeof this.props.application.timerConfig === 'undefined') {
      this.props.application.timerConfig = {
        flags: 0,
        timerItems: [],
      };
    }
    if (typeof this.props.application.alarmConfig === 'undefined') {
      this.props.application.alarmConfig = {
        flags: 0,
        alarmItems: [],
      };
    }

    this.setState({
      application: this.props.application,
      isGlobalAdmin: SessionStore.isAdmin(),
    }, () => {
      this.setSelectedOrganization();
    });

    SessionStore.on("change", () => {
      this.setState({
        isGlobalAdmin: SessionStore.isAdmin(),
      });
    });
  }

  // 从服务器获取了配置下来
  componentWillReceiveProps(nextProps) {
    if (typeof nextProps.application.rs485Config === 'undefined') {
      nextProps.application.rs485Config = {};
    }
    if (typeof nextProps.application.rs485Config.serialConfig === 'undefined') {
      nextProps.application.rs485Config.serialConfig = {
        devType: 0,
        baudrate: 6,
        stopbit: 0,
        parity: 0,
        addrSize: 4,
        hdlcDstHigh: '',
        hdlcDstLow: '',
        wrapperSrc: '',
        wrapperDst: '',
        authLevel: 0,
        authPasswd: '',
      };
    }
    if (typeof nextProps.application.rs485Config.dlmsRegs === 'undefined') {
      nextProps.application.rs485Config.dlmsRegs = [];
    }
    if (typeof nextProps.application.rs485Config.regs === 'undefined') {
      nextProps.application.rs485Config.regs = [];
    }
    if (typeof nextProps.application.rs485Config.reports === 'undefined') {
      nextProps.application.rs485Config.reports = [];
    }

    if (typeof nextProps.application.bacnetConfig === 'undefined') {
      nextProps.application.bacnetConfig = [];
    }

    if (nextProps.application.rs485Config.serialConfig.baudrate === 0) {
      nextProps.application.rs485Config.serialConfig.baudrate = 6;
    }
    if (nextProps.application.rs485Config.serialConfig.devType === 2) {
      nextProps.application.rs485Config.serialConfig.addrSize = 2;
    } else if (nextProps.application.rs485Config.serialConfig.devType === 1 && nextProps.application.rs485Config.serialConfig.addrSize === 0) {
      nextProps.application.rs485Config.serialConfig.addrSize = 4;
    }

    if (typeof nextProps.application.timerConfig === 'undefined') {
      nextProps.application.timerConfig = {
        flags: 0,
        timerItems: [],
      };
    }
    
    if (typeof nextProps.application.alarmConfig === 'undefined') {
      nextProps.application.alarmConfig = {
        flags: 0,
        alarmItems: [],
      };
    }

    this.setState({
      appTypeDisabled: typeof nextProps.application.appType !== "undefined",
      application: nextProps.application,
      isProps: true,
    }, () => {
      this.setSelectedOrganization();
    });
  }

  onChange(field, e) {
    let application = this.state.application;
    if (e.target.type === "number" || field === "appType") {
      application[field] = parseInt(e.target.value, 10); 
      if (field === "appType") {
        if (application.appType === 1) { // RS485 bridge
          application.rs485Config.serialConfig.devType = 0;
        } else if (application.appType === 3) { // DLMS
          if (application.rs485Config.serialConfig.devType !== 1 && application.rs485Config.serialConfig.devType !== 2) {
            application.rs485Config.serialConfig.devType = 1;
          }
        }
      }
    } else if (e.target.type === "checkbox") {
      application[field] = e.target.checked;
    } else {
      application[field] = e.target.value;
    }
    this.setState({application: application});
  }

  onSerialChange(field, e) {
    let application = this.state.application;
    //console.log("onSerialChange field: ", field, ", type: ", e.target.type);
    if (e.target.type === "number" || e.target.type === "select" || e.target.type === 'select-one') {
        application.rs485Config.serialConfig[field] = parseInt(e.target.value, 10); 
    } else if (e.target.type === "checkbox") {
      application.rs485Config.serialConfig[field] = e.target.checked;
    } else {
      application.rs485Config.serialConfig[field] = e.target.value;
    }

    if (application.rs485Config.serialConfig.devType === 2) {
      application.rs485Config.serialConfig.addrSize = 2;
    }

    this.setState({application: application});
  }

  // 要submit配置时，重新构造配置提交服务器
  buildBACnetConfig(abs) {
    let config = {bacnetItems: []};

    for (let i = 0; i < abs.length; i++) {
      if ( ! abs[i].enable )
        continue;
      config.bacnetItems.push({name: abs[i].name, unit: abs[i].unit, mul: abs[i].mul});
    }

    return config;
  }

  handleSubmit(e) {
    e.preventDefault();

    let app = this.state.application;

    if (app.appType === 3) { // DLMS
      if (app.rs485Config.serialConfig.authLevel !== 0 && app.rs485Config.serialConfig.authPasswd.length !== 8) {
        alert('Please input 8 characters DLMS authentication password');
        return;
      }
      if (app.rs485Config.serialConfig.devType !== 1 && app.rs485Config.serialConfig.devType !== 2) {
        app.rs485Config.serialConfig.devType = 1;
      }
      if (app.rs485Config.serialConfig.devType === 2) {
        app.rs485Config.serialConfig.addrSize = 2;
      }
    } else if (app.appType === 1) { // RS485 bridge
      if (app.rs485Config.serialConfig.devType !== 0) {
        app.rs485Config.serialConfig.devType = 0;
      }
    }else if (app.appType === 2){// RS485 slave
      const cmpalarmformula = /^x([1-9][0-9]*)(\s*)[<=>](\s*)-?\d*(\.\d+)?$/ //xn < ||  >  int || float 
      const reportsformula = /^r([0-9]+)$/ //xn < ||  >  int || float 
      for (let i = 0; i < app.alarmConfig.alarmItems.length; i++) {
        const obj = app.alarmConfig.alarmItems[i];
        if (obj.localalarm === true) {
          if (! cmpalarmformula.test(obj.formula)) {
              alert(`The input local alarm expression does not conform to the specification. errorformula = ${obj.formula}`);
              return
          } 
          let match = obj.formula.match(cmpalarmformula);
          if (match) {
            const number = match[1];
            if (number <= 0) {
              alert(`The n of xn is less than or equal to 0. errorformula = ${obj.formula}`);
              return
            }else if (number > app.rs485Config.reports.length ){
              alert(`The configured index value is greater than the length of Reports. errorformula = ${obj.formula}`);
              return
            }
            if (! reportsformula.test(app.rs485Config.reports[number-1].formula)) {
              alert(`The corresponding expression in Reports does not meet the standard. errorformula = ${app.rs485Config.reports[number-1].formula}`);
              return
            } 
            match = app.rs485Config.reports[number-1].formula.match(reportsformula)
            if (match) {
              let addrexist = false;
              const regaddr = Number(match[1])
              for (let index = 0; index < app.rs485Config.regs.length; index++) {
                const element = app.rs485Config.regs[index];
                if (element.regAddress === regaddr) {
                  addrexist =true
                }
              }
              if (!addrexist) {
                alert(`The register address does not exist in Reporrts. errorformula = ${app.rs485Config.reports[number-1].formula}`);
                return
              }
            }else{
              alert(`Reports error, corresponding register address not found. errorformula = ${app.rs485Config.reports[number-1].formula}`);
              return
            }
          } else {
            alert(`x should be followed by integers greater than 0. errorformula = ${obj.formula}`);
            return
          }
        }
      }
    }

    app.bacnetConfig = this.buildBACnetConfig(this.state.allBacnet);

    if (typeof app.description === 'undefined') {
      app.description = '';
    }
    //app.isClassC = false;
    app.rxWindow = "RX1";
    app.relaxFCnt = true;
    app.rx1DROffset = 0;
    if (typeof app.rxDelay === 'undefined' || app.rxDelay === 0) {
      app.rxDelay = 2;
    }
    if (typeof app.rx2DR === 'undefined' || app.rx2DR === 0) {
      app.rx2DR = 2;
    }
    //app.rx2DR = 0;
    app.adrInterval = 0;
    app.installationMargin = 0.0;
    if (app.bandID === 0)
      app.bandID = 1;

    this.props.onSubmit(app);
  }

  handleAddExReading(e) {
    let application = this.state.application;

    e.preventDefault();
    if (typeof application.exReading === 'undefined') {
      application.exReading = [];
    }
    application.exReading.push({})

    this.setState({application : application});
  }

  changeExReading(index, field, e) {
    let app = this.state.application;
    if (e.target.type === "number") {
      app.exReading[index][field] = parseInt(e.target.value, 10);
    } else if (e.target.type === "checkbox") {
      app.exReading[index][field] = e.target.checked;
    } else {
      app.exReading[index][field] = e.target.value;
    }
    
    this.setState({application : app});
  }

  deleteExReading(index) {
    let app = this.state.application;
    app.exReading.splice(index, 1);
    this.setState({application : app});  
  }

  handleAddTimer(e) {
    let application = this.state.application;

    e.preventDefault();
    if (typeof application.timerConfig === 'undefined' || typeof application.timerConfig.timerItems === 'undefined') {
      application.timerConfig = {
        flags: 0,
        timerItems: [],
      };
    }
    application.timerConfig.timerItems.push({
      timerType: 0,
      time: '',
      action: 1,
      brightness: 100,
    })

    this.setState({application : application});
  }

  changeTimer(index, field, e) {
    let app = this.state.application;
    if (e.target.type === "number") {
      app.timerConfig.timerItems[index][field] = parseInt(e.target.value, 10);
    } else if (e.target.type === "checkbox") {
      app.timerConfig.timerItems[index][field] = e.target.checked;
    } else {
      app.timerConfig.timerItems[index][field] = e.target.value;
    }
    this.setState({application : app});
  }

  deleteTimer(index) {
    let app = this.state.application;
    app.timerConfig.timerItems.splice(index, 1);
    this.setState({application : app});  
  }


  handleAddDlms(e) {
    let application = this.state.application;

    e.preventDefault();
    if (typeof application.rs485Config.dlmsRegs === 'undefined') {
      application.rs485Config.dlmsRegs = [];
    }
    application.rs485Config.dlmsRegs.push({
      name: '',
      classID: 3,
      obis: '',
      attr: 2,
      mul: 0,
      ratio: 1,
    })

    this.setState({application : application});
  }

  changeDlms(index, field, e) {
    let app = this.state.application;
    if (e.target.type === "number") {
      app.rs485Config.dlmsRegs[index][field] = parseInt(e.target.value, 10);
    } else if (e.target.type === "checkbox") {
      app.rs485Config.dlmsRegs[index][field] = e.target.checked;
    } else {
      app.rs485Config.dlmsRegs[index][field] = e.target.value;
    }
    this.setState({application : app});
  }

  deleteDlms(index) {
    let app = this.state.application;
    app.rs485Config.dlmsRegs.splice(index, 1);
    this.setState({application : app});  
  }  

  handleAddRegister(e) {
    let application = this.state.application;

    e.preventDefault();
    if (typeof application.rs485Config.regs === 'undefined') {
      application.rs485Config.regs = [];
    }
    application.rs485Config.regs.push({cmd: 3, regType: "uint16"})

    this.setState({application : application});
  }

  changeRegister(index, field, e) {
    let app = this.state.application;
    if (e.target.type === "number") {
      app.rs485Config.regs[index][field] = parseInt(e.target.value, 10);
    } else if (e.target.type === "checkbox") {
      app.rs485Config.regs[index][field] = e.target.checked;
    } else {
      app.rs485Config.regs[index][field] = e.target.value;
    }
    this.setState({application : app});
  }

  deleteRegister(index) {
    let app = this.state.application;
    app.rs485Config.regs.splice(index, 1);
    this.setState({application : app});  
  }

  handleAddReport(e) {
    let application = this.state.application;
    
    e.preventDefault();
    if (typeof application.rs485Config.reports === 'undefined') {
      application.rs485Config.reports = [];
    }
    application.rs485Config.reports.push({scale: 0})
    
    this.setState({application : application});
  }

  changeReport(index, field, e) {
    let app = this.state.application;
    if (e.target.type === "number") {
      app.rs485Config.reports[index][field] = parseInt(e.target.value, 10);
    } else if (e.target.type === "checkbox") {
      app.rs485Config.reports[index][field] = e.target.checked;
    } else {
      app.rs485Config.reports[index][field] = e.target.value;
    }
    this.setState({application : app});
  }

  deleteReport(index) {
    let app = this.state.application;
    app.rs485Config.reports.splice(index, 1);
    this.setState({application : app});  
  }


  handleAddAlarm(e) {
    let application = this.state.application;
    
    e.preventDefault();
    if ( ! application.alarmConfig ) {
      application.alarmConfig = {flags: 0, alarmItems: []};
    }
    if ( ! application.alarmConfig.alarmItems ) {
      application.alarmConfig.alarmItems = [];
    }
    application.alarmConfig.alarmItems.push({
      msg: '',
      formula: '',
      localalarm:false,
    });
    
    this.setState({application : application});
  }

  changeAlarm(index, field, e) {
    let app = this.state.application;
    if (e.target.type === "number") {
      app.alarmConfig.alarmItems[index][field] = parseInt(e.target.value, 10);
    } else if (e.target.type === "checkbox") {
      app.alarmConfig.alarmItems[index][field] = e.target.checked;
    } else {
      app.alarmConfig.alarmItems[index][field] = e.target.value;
    }
    this.setState({application : app});
  }

  deleteAlarm(index) {
    let app = this.state.application;
    app.alarmConfig.alarmItems.splice(index, 1);
    this.setState({application : app});  
  }


  onDisplayChange(id, e) {
    let app = this.state.application;

    if (e.target.checked) { /* display */
      this.hideListDel(id);
    } else {
      this.hideListAdd(id);
    }

    this.setState({application : app});  
  }


  changeTab(e) {
    e.preventDefault();
    this.setState({
      activeTab: e.target.getAttribute('aria-controls'),
    });
  }

  onOrganizationAutocomplete(input, callbackFunc) {
    OrganizationStore.getAll(input, 999, 0, (totalCount, orgs) => {
      const options = orgs.map((org, i) => {
        return {
          value: org.id,
          label: org.displayName,
        };
      });

      callbackFunc(null, {
        options: options,
        complete: true,
      });
    });
  }

  onOrganizationSelect(val) {
    let application = this.state.application;
    application.organizationID = val.value;
    this.setState({
      application: application,
      initialOrganizationOptions: [val],
    });
  }

  setSelectedOrganization() {
    if (typeof(this.state.application.organizationID) === "undefined") {
      return;
    }
    OrganizationStore.getOrganization(this.state.application.organizationID, (org) => {
      this.setState({
        initialOrganizationOptions: [{
          value: org.id,
          label: org.displayName,
        }],
      });
    });
  }

  setInitialOrganizations() {
    OrganizationStore.getAll("", 999, 0, (totalCount, orgs) => {
      const options = orgs.map((org, i) => {
        return {
          value: org.id,
          label: org.displayName,
        };
      });

      this.setState({
        initialOrganizationOptions: options,
      });
    });
  }

  // 2 - RS485 slave meter
  // 5 - EDMI Mk10E Energy Meter
  hasRegReport(at) {
    if (at === 2 || at === 5) {
      return true;
    }
    return false;
  }

  render() {
    let ExReadingList = '';
    let RegisterList = '';
    let ReportList = '';
    let DlmstList = '';
    let AlarmList = '';
    let BasicDisplay = '';
    let ExtendedDisplay = '';
    let TimerList = '';
    let BacnetList = '';

    let app = this.state.application;
    
    if (app.appType === 2) {
      BasicDisplay = this.state.allSubMeterBaiscDisplay.map((item, i) =>
        <DisplayComponent id={item.id} name={item.name} hide={this.hideListInclude(app.hideDisplay, item.id)} 
        onDisplayChange={this.onDisplayChange} application={app}/>);
    } else {
      BasicDisplay = this.state.allLoRaNodeBaiscDisplay.map((item, i) =>
        <DisplayComponent id={item.id} name={item.name} hide={this.hideListInclude(app.hideDisplay, item.id)} 
        onDisplayChange={this.onDisplayChange} application={app}/>);
    }

    BacnetList = this.state.allBacnet.map((item, i) =>
      <BACnetComponent id={item.name} index={i} name={item.name} enable={item.enable} 
        unit={item.unit} mul={item.mul}
        onChangeBACnet={this.onChangeBACnet} application={app}/>);


    if (typeof app.exReading !== 'undefined') {
      ExReadingList = app.exReading.map((item, i) => 
        <ExReadingComponent name={item.name} eid={item.eid}
          unit={item.unit} formula={item.formula} scale={item.scale} index={i} 
          deleteExReading={this.deleteExReading} 
          changeExReading={this.changeExReading}/>);
 
      if ( ! this.hasRegReport(app.appType) ) {
        ExtendedDisplay = app.exReading.map((item, i) => 
        <DisplayComponent id={''+item.eid} name={item.name} application={app}
          hide={this.hideListInclude(app.hideDisplay, ''+item.eid)} onDisplayChange={this.onDisplayChange}/>); 
      }
    }

    if (typeof app.timerConfig !== 'undefined' && typeof app.timerConfig.timerItems !== 'undefined') {
      TimerList = app.timerConfig.timerItems.map((item, i) => 
        <TimerComponent timerType={item.timerType} time={item.time}
          action={item.action} brightness={item.brightness} index={i}
          deleteTimer={this.deleteTimer} 
          changeTimer={this.changeTimer}/>);
    }

    if (typeof app.rs485Config !== 'undefined') {
      if (typeof app.rs485Config.dlmsRegs !== 'undefined') {
        DlmstList = app.rs485Config.dlmsRegs.map((item, i) => 
          <DlmsComponent index={i} 
            name={item.name} classID={item.classID}
            obis={item.obis} attr={item.attr} mul={item.mul} ratio={item.ratio}
            deleteDlms={this.deleteDlms} 
            changeDlms={this.changeDlms}/>);
      }
  
      if (typeof app.rs485Config.regs !== 'undefined') {
        RegisterList = app.rs485Config.regs.map((item, i) => 
          <RegisterComponent apptype={app.appType} name={item.name} cmd={item.cmd}
            regAddress={item.regAddress} regType={item.regType}
            index={i} deleteRegister={this.deleteRegister} 
            changeRegister={this.changeRegister}/>);
      }
  
      if (typeof app.rs485Config.reports !== 'undefined') {
        ReportList = app.rs485Config.reports.map((item, i) => 
          <ReportComponent id={item.id} name={item.name} formula={item.formula} scale={item.scale}
            index={i} deleteReport={this.deleteReport}
            changeReport={this.changeReport} />);   

        if (this.hasRegReport(app.appType)) {
          ExtendedDisplay = app.rs485Config.reports.map((item, i) => 
          <DisplayComponent id={''+item.id} name={item.name} application={app}
            hide={this.hideListInclude(app.hideDisplay, ''+item.id)} onDisplayChange={this.onDisplayChange}/>); 
        }
      }
    }

    if (app.alarmConfig && app.alarmConfig.alarmItems) {
      AlarmList = app.alarmConfig.alarmItems.map((item, i) => 
        <AlarmComponent index={i} msg={item.msg} formula={item.formula} localalarm={item.localalarm || false}
          deleteAlarm={this.deleteAlarm} changeAlarm={this.changeAlarm}/>);
    }

    let at = app.appType;
    // 有时候为了调试，可以设置成false
    let hideTab = true

    return (
      <div>
        <ul className="nav nav-tabs">
          <li role="presentation" className={(this.state.activeTab === "application" ? 'active' : '')}><a onClick={this.changeTab} href="#application" aria-controls="application">Application details</a></li>
          <li role="presentation" className={((at === 2 && hideTab) ? 'hidden' : (this.state.activeTab === "network-settings" ? 'active' : ''))}><a onClick={this.changeTab} href="#network-settings" aria-controls="network-settings">Network settings</a></li>
          <li role="presentation" className={(((at === 1 || at === 3 || at === 5) && hideTab) ? (this.state.activeTab === "serial-port" ? 'active' : '') : 'hidden')}><a onClick={this.changeTab} href="#serial-port" aria-controls="serial-port">Serial port</a></li>
          <li role="presentation" className={((at === 1 || at === 2 || at === 5) && hideTab) ? 'hidden' : (this.state.activeTab === "ex-reading" ? 'active' : '')}><a onClick={this.changeTab} href="#ex-reading" aria-controls="ex-reading">Extend meter reading</a></li>
          <li role="presentation" className={(((at === 4) && hideTab) ? (this.state.activeTab === "timer" ? 'active' : '') : 'hidden')}><a onClick={this.changeTab} href="#timer" aria-controls="timer">Timer</a></li>
          <li role="presentation" className={((at !== 3 && hideTab) ? 'hidden' : (this.state.activeTab === "rs485-dlms" ? 'active' : ''))}><a onClick={this.changeTab} href="#rs485-dlms" aria-controls="rs485-dlms">DLMS</a></li>
          <li role="presentation" className={((at !== 2 && at !== 5 && hideTab) ? 'hidden' : (this.state.activeTab === "rs485-registers" ? 'active' : ''))}><a onClick={this.changeTab} href="#rs485-registers" aria-controls="rs485-registers">{this.state.customServer === "mhs" ? "Modbus Addr" : "Registers"}</a></li>
          <li role="presentation" className={((at !== 2 && at !== 5 && hideTab) ? 'hidden' : (this.state.activeTab === "rs485-reports" ? 'active' : ''))}><a onClick={this.changeTab} href="#rs485-reports" aria-controls="rs485-reports">{this.state.customServer === "mhs" ? "Value Format" : "Reports"}</a></li>
          <li role="presentation" className={(this.state.activeTab === "bacnet" ? 'active' : '')}><a onClick={this.changeTab} href="#bacnet" aria-controls="bacnet">BACnet</a></li>
          <li role="presentation" className={(this.state.activeTab === "alarm-settings" ? 'active' : '')}><a onClick={this.changeTab} href="#alarm-settings" aria-controls="alarm-settings">Alarm settings</a></li>
          <li role="presentation" className={(this.state.activeTab === "display" ? 'active' : '')}><a onClick={this.changeTab} href="#display" aria-controls="display">Display settings</a></li>
        </ul>
        <hr />
        <form onSubmit={this.handleSubmit}>
          <div className={(this.state.activeTab === "application" ? '' : 'hidden')}>
            <div className="form-group">
              <label className="control-label" htmlFor="name">Application name</label>
              <input className="form-control" id="name" type="text" placeholder="e.g. 'temperature-sensor'" required value={app.name || ''} onChange={this.onChange.bind(this, 'name')} />
              <p className="help-block">
                The name may only contain words, numbers and dashes. 
              </p>
            </div>
            <div className="form-group">
              <label className="control-label" htmlFor="appType">Application type</label>
              <select className="form-control" id="appType" name="appType" disabled={this.state.appTypeDisabled} value={app.appType  || 0} onChange={this.onChange.bind(this, "appType")}>
                <option key="0" value="0">LoRa meter</option>
                <option key="1" value="1">RS485 bridge</option>
                <option key="2" value="2">RS485 slave meter</option>
                <option key="3" value="3">RS485 DLMS Energy Meter</option>
                <option key="5" value="5">EDMI Mk10E Energy Meter</option>
                <option key="4" value="4">LED light</option>
                <option key="1001" value="1001">Transparent transmission</option>
                <option key="1002" value="1002">Winext temperature humidity sensor</option>
                <option key="1003" value="1003">Cayenne LPP sensor</option>
                <option key="1004" value="1004">Vaccine box sensor</option>
                <option key="1005" value="1005">Bathroom Odor Detector Sensor</option>
                <option key="1006" value="1006">Indoor Ambiance Monitoring Sensor</option>
                <option key="1007" value="1007">PIR & Light Sensor</option>
              </select>
            </div>
            <div className="form-group">
              <label className="control-label" htmlFor="name">Application description</label>
              <input className="form-control" id="description" type="text" placeholder="a short description of your application" value={app.description || ''} onChange={this.onChange.bind(this, 'description')} />
            </div>
            <div className={"form-group " + (this.state.isGlobalAdmin && this.props.update ? '' : 'hidden')}>
              <label className="control-label" htmlFor="organization">Organization</label>
              <Select.Async
                name="organization"
                required
                options={this.state.initialOrganizationOptions}
                loadOptions={this.onOrganizationAutocomplete}
                value={app.organizationID}
                onChange={this.onOrganizationSelect}
                clearable={false}
                autoload={false}
                onOpen={this.setInitialOrganizations}
              /> 
              <p className="help-block">Note that moving an application to a different organization can only be done by global admin users.</p>
            </div>
          </div>

          <div className={(this.state.activeTab === "network-settings" && at !== 2 ? '' : 'hidden')}>
            <div className="form-group">
              <label className="control-label">Class-C nodes</label>
              <div className="checkbox">
                <label>
                  <input type="checkbox" name="isClassC" id="isClassC" checked={app.isClassC} onChange={this.onChange.bind(this, 'isClassC')} /> Class-C nodes
                </label>
              </div>
              <p className="help-block">
                When checked, it means that the nodes for this application are operating in Class-C mode (always listening) and that data will be sent directly to the node. <br/>
                In any other case, the data will be sent as soon as a receive window occurs.
              </p>
            </div>
            <div className="form-group">
              <label className="control-label">ABP (activation by personalisation)</label>
              <div className="checkbox">
                <label>
                  <input type="checkbox" name="isABP" id="isABP" checked={app.isABP} onChange={this.onChange.bind(this, 'isABP')} /> ABP activation
                </label>
              </div>
              <p className="help-block">When checked, it means that the nodes for this application will be manually activated and that over-the-air activation (OTAA) will be disabled.</p>
            </div>
            <div className="form-group hidden">
              <label className="control-label">Receive window</label>
              <div className="radio">
                <label>
                  <input type="radio" name="rxWindow" id="rxWindow1" value="RX1" checked={app.rxWindow === "RX1"} onChange={this.onChange.bind(this, 'rxWindow')} /> RX1
                </label>
              </div>
              <div className="radio">
                <label>
                  <input type="radio" name="rxWindow" id="rxWindow2" value="RX2" checked={app.rxWindow === "RX2"} onChange={this.onChange.bind(this, 'rxWindow')} /> RX2 (one second after RX1)
                </label>
              </div>
            </div>
            <div className="form-group hidden">
              <label className="control-label">Relax frame-counter</label>
              <div className="checkbox">
                <label>
                  <input type="checkbox" name="relaxFCnt" id="relaxFCnt" checked={app.relaxFCnt} onChange={this.onChange.bind(this, 'relaxFCnt')} /> Enable relax frame-counter
                </label>
              </div>
              <p className="help-block">Note that relax frame-counter mode will compromise security as it enables people to perform replay-attacks.</p>
            </div>
            <div className="form-group">
              <label className="control-label" htmlFor="rxDelay">Receive window delay</label>
              <input className="form-control" id="rxDelay" type="number" min="0" max="15" required value={app.rxDelay || 2} onChange={this.onChange.bind(this, 'rxDelay')} />
              <p className="help-block">The delay in seconds (0-15) between the end of the TX uplink and the opening of the first reception slot (0=1 sec, 1=1 sec, 2=2 sec, 3=3 sec, ... 15=15 sec).</p>
            </div>
            <div className="form-group hidden">
              <label className="control-label" htmlFor="rx1DROffset">RX1 data-rate offset</label>
              <input className="form-control" id="rx1DROffset" type="number" required value={app.rx1DROffset || 0} onChange={this.onChange.bind(this, 'rx1DROffset')} />
              <p className="help-block">
                Sets the offset between the uplink data rate and the downlink data-rate used to communicate with the end-device on the first reception slot (RX1).
                Please refer to the LoRaWAN specs for the values that are valid in your region.
              </p>
            </div>
            <div className="form-group">
              <label className="control-label" htmlFor="rx2DR">RX2 data-rate</label>
              <input className="form-control" id="rx2DR" type="number" required value={app.rx2DR || 2} onChange={this.onChange.bind(this, 'rx2DR')} />
              <p className="help-block">
                The data-rate to use when RX2 is used as receive window.
                Please refer to the LoRaWAN specs for the values that are valid in your region.
              </p>
            </div>
            <div className="form-group">
              <label className="control-label" htmlFor="bandID">ISM Band</label>
              <select className="form-control" id="bandID" name="bandID" value={app.bandID  || 1} onChange={this.onChange.bind(this, "bandID")}>
                {
                  this.state.bands.map((b, i) => {
                    return (<option key={b.id} value={b.id}>{b.name}</option>);
                  })
                }
              </select>
              <p className="help-block">
                Different region may use different ISM band. LoRaWAN has defined some ISM bands, and you can define
                your bands with different channel list.
              </p>
            </div>
            <div className="form-group">
              <label className="control-label" htmlFor="channelListID">Channel-list</label>
              <select className="form-control" id="channelListID" name="channelListID" value={app.channelListID} onChange={this.onChange.bind(this, "channelListID")}>
                <option value="0"></option>
                {
                  this.state.channelLists.map((cl, i) => {
                    return (<option key={cl.id} value={cl.id}>{cl.name}</option>);
                  })
                }
              </select>
              <p className="help-block">
                Some LoRaWAN ISM bands implement an optional channel-frequency list that can be sent when using OTAA.
                Please refer to the LoRaWAN specs for the values that are valid in your region.
              </p>
            </div>
            <div className="form-group hidden">
              <label className="control-label" htmlFor="adrInterval">ADR interval</label>
              <input className="form-control" id="adrInterval" type="number" required value={app.adrInterval || 0} onChange={this.onChange.bind(this, 'adrInterval')} />
              <p className="help-block">
                The interval (of frames) after which the network-server will ask the nodes for this application to change data-rate and / or TX power
                if it can change to a better data-rate or lower TX power. Setting this to 0 will disable ADR. 
              </p>
            </div>
            <div className="form-group hidden">
              <label className="control-label" htmlFor="installationMargin">Installation margin (dB)</label>
              <input className="form-control" id="installationMargin" type="number" required value={app.installationMargin || 0} onChange={this.onChange.bind(this, 'installationMargin')} />
              <p className="help-block">
                The installation margin which is taken into account when calculating the ideal data-rate and TX power.
                A higher margin will lower the data-rate, a lower margin will increase the data-rate and possibly packet loss.
                5dB is the default recommended value.
              </p>
            </div>
          </div>

          <div className={(this.state.activeTab === "serial-port" ? '' : 'hidden')}>
            <div className="form-group">
              <label className="control-label" htmlFor="baudrate">Baudrate</label>
              <select className="form-control" id="baudrate" name="baudrate" value={app.rs485Config.serialConfig.baudrate || 6} onChange={this.onSerialChange.bind(this, "baudrate")}>
                <option key="1" value="1">300</option>
                <option key="2" value="2">600</option>
                <option key="3" value="3">1200</option>
                <option key="4" value="4">2400</option>
                <option key="5" value="5">4800</option>
                <option key="6" value="6">9600</option>
                <option key="7" value="7">19200</option>
                <option key="8" value="8">38400</option>
                <option key="9" value="9">57600</option>
                <option key="10" value="10">115200</option>
              </select>
              <p className="help-block">
                RS485 baudrate.
              </p>
            </div>
            <div className="form-group">
              <label className="control-label" htmlFor="stopbit">Stopbit</label>
              <select className="form-control" id="stopbit" name="stopbit" value={app.rs485Config.serialConfig.stopbit || 0} onChange={this.onSerialChange.bind(this, "stopbit")}>
                <option key="0" value="0">1</option>
                <option key="1" value="1">1.5</option>
                <option key="2" value="2">2</option>
              </select>
              <p className="help-block">
                RS485 stopbit.
              </p>
            </div>
            <div className="form-group">
              <label className="control-label" htmlFor="parity">Parity</label>
              <select className="form-control" id="parity" name="parity" value={app.rs485Config.serialConfig.parity || 0} onChange={this.onSerialChange.bind(this, "parity")}>
                <option key="0" value="0">None</option>
                <option key="1" value="1">Odd</option>
                <option key="2" value="2">Even</option>
              </select>
              <p className="help-block">
                RS485 parity.
              </p>
            </div>
          </div>


          <div className={(this.state.activeTab === "ex-reading" ? '' : 'hidden')}>
            {ExReadingList}
            <br />
          </div>

          <div className={(this.state.activeTab === "timer" ? '' : 'hidden')}>
            {TimerList}
            <br />
          </div>

          <div className={(this.state.activeTab === "rs485-registers" ? '' : 'hidden')}>
            {RegisterList}
            <br />
          </div>

          <div className={(this.state.activeTab === "rs485-reports" ? '' : 'hidden')}>
            {ReportList}
            <br />
          </div>

          <div className={(this.state.activeTab === "rs485-dlms" ? '' : 'hidden')}>
            <div className="form-group">
              <label className="control-label" htmlFor="devType">Link layer type</label>
              <select className="form-control" id="devType" name="devType" value={app.rs485Config.serialConfig.devType || 1} onChange={this.onSerialChange.bind(this, "devType")}>
                <option key="1" value="1">DLMS/COSEM IEC62056-46(HDLC)</option>
                <option key="2" value="2">DLMS/COSEM IEC62056-47(Wrapper)</option>
              </select>
            </div>

            <div className={(app.rs485Config.serialConfig.devType === 2 ? 'hidden' : 'form-group')}>
              <label className="control-label" htmlFor="addrSize">Size of HDLC destination address</label>
              <select className="form-control" id="addrSize" name="addrSize" value={app.rs485Config.serialConfig.addrSize} onChange={this.onSerialChange.bind(this, "addrSize")}>
                <option key="1" value="1">1</option>
                <option key="2" value="2">2</option>
                <option key="4" value="4">4</option>
              </select>
            </div>

            <div className={(app.rs485Config.serialConfig.devType === 2 ? 'hidden' : 'form-group')}>
              <label className="control-label" htmlFor="hdlcSrc">HDLC client address</label>
              <input className="form-control" id="hdlcSrc" type="text" value={app.rs485Config.serialConfig.hdlcSrc} onChange={this.onSerialChange.bind(this, 'hdlcSrc')} />
              <p className="help-block">
                Hex, 1 byte, source address of HDLC frame. Like: 1a
              </p>
            </div>

            <div className={(app.rs485Config.serialConfig.devType === 2 ? 'hidden' : 'form-group')}>
              <label className="control-label" htmlFor="hdlcDstHigh">HDLC logical device</label>
              <input className="form-control" id="hdlcDstHigh" type="text" value={app.rs485Config.serialConfig.hdlcDstHigh} onChange={this.onSerialChange.bind(this, 'hdlcDstHigh')} />
              <p className="help-block">
                Hex, destination high address of HDLC frame. Like: 001a
              </p>
            </div>

            <div className={(app.rs485Config.serialConfig.devType === 2 ? 'hidden' : 'form-group')}>
              <label className="control-label" htmlFor="hdlcDstLow">HDLC physical address</label>
              <input className="form-control" id="hdlcDstLow" type="text" value={app.rs485Config.serialConfig.hdlcDstLow} onChange={this.onSerialChange.bind(this, 'hdlcDstLow')} />
              <p className="help-block">
                Hex, destination high address of HDLC frame. Like: 001a
              </p>
            </div>

            <div className={(app.rs485Config.serialConfig.devType !== 2 ? 'hidden' : 'form-group')}>
              <label className="control-label" htmlFor="wrapperSrc">Wrapper client address</label>
              <input className="form-control" id="wrapperSrc" type="text" value={app.rs485Config.serialConfig.wrapperSrc} onChange={this.onSerialChange.bind(this, 'wrapperSrc')} />
              <p className="help-block">
                Hex, 2 bytes, source port of wrapper frame. Like: 002a
              </p>
            </div>

            <div className={(app.rs485Config.serialConfig.devType !== 2 ? 'hidden' : 'form-group')}>
              <label className="control-label" htmlFor="wrapperDst">Wrapper server address</label>
              <input className="form-control" id="wrapperDst" type="text" value={app.rs485Config.serialConfig.wrapperDst} onChange={this.onSerialChange.bind(this, 'wrapperDst')} />
              <p className="help-block">
                Hex, 2 bytes, destination port of wrapper frame. Like: 002a
              </p>
            </div>

            <div className="form-group">
              <label className="control-label" htmlFor="authLevel">Authentication level</label>
              <select className="form-control" id="authLevel" name="authLevel" value={app.rs485Config.serialConfig.authLevel} onChange={this.onSerialChange.bind(this, "authLevel")}>
                <option key="0" value="0">0: lowest level</option>
                <option key="1" value="1">1: low level</option>
              </select>
            </div>

            <div className={(app.rs485Config.serialConfig.authLevel === 0 ? 'hidden' : 'form-group')}>
              <label className="control-label" htmlFor="authPasswd">Authentication password</label>
              <input className="form-control" id="authPasswd" type="text" value={app.rs485Config.serialConfig.authPasswd} onChange={this.onSerialChange.bind(this, 'authPasswd')} />
              <p className="help-block">
                Authentication password, 8 characters.
              </p>
            </div>

            {DlmstList}
            <br />
          </div>

          <div className={(this.state.activeTab === "bacnet" ? '' : 'hidden')}>
            {BacnetList}
            <br />
          </div>

          <div className={(this.state.activeTab === "alarm-settings" ? '' : 'hidden')}>
            {AlarmList}
            <br />
          </div>

          <div className={(this.state.activeTab === "display" ? '' : 'hidden')}>
            <div className="panel panel-default">
              <div className="panel panel-heading">Display basic information</div>
              <div className="panel-body">
                {BasicDisplay}
              </div>
            </div>
            
            <div className={'panel panel-default' + (ExtendedDisplay === '' ? ' hidden' :'')}>
              <div className="panel panel-heading">Display extended information</div>
              <div className="panel-body">
                {ExtendedDisplay}
              </div>
            </div>
          </div>

          <hr />

          <div className="btn-group pull-right" role="group" aria-label="...">
            &nbsp;<Link className={(this.state.activeTab === "ex-reading" ? '' : 'hidden')}><button type="button" onClick={this.handleAddExReading.bind(this)} className="btn btn-default">Add Reading</button></Link>
            &nbsp;<Link className={(this.state.activeTab === "timer" && at === 4 ? '' : 'hidden')}><button type="button" onClick={this.handleAddTimer.bind(this)} className="btn btn-default">Add timer</button></Link>
            &nbsp;<Link className={(this.state.activeTab === "rs485-registers" && (at === 2 || at === 5) ? '' : 'hidden')}><button type="button" onClick={this.handleAddRegister.bind(this)} className="btn btn-default">Add register</button></Link>
            &nbsp;<Link className={(this.state.activeTab === "rs485-reports" && (at === 2 || at === 5) ? '' : 'hidden')}><button type="button" onClick={this.handleAddReport.bind(this)} className="btn btn-default">Add report</button></Link>
            &nbsp;<Link className={(this.state.activeTab === "rs485-dlms" && at === 3 ? '' : 'hidden')}><button type="button" onClick={this.handleAddDlms.bind(this)} className="btn btn-default">Add register</button></Link>
            &nbsp;<Link className={(this.state.activeTab === "alarm-settings" ? '' : 'hidden')}><button type="button" onClick={this.handleAddAlarm.bind(this)} className="btn btn-default">Add alarm</button></Link>
            &nbsp;<Link><button type="submit" className="btn btn-primary pull-right">Submit</button></Link>
          </div>

        </form>
      </div>
    );
  }
}

export default ApplicationForm;



// WEBPACK FOOTER //
// ./src/components/ApplicationForm.js